import { useTranslation } from 'react-i18next'

import { Option } from '@/Atomic/Molecules/Inputs/Select/types'
import { SimpleSelect } from '@/Atomic/Molecules/SimpleSelect'
import { useFilterValues } from '@/Components/FormContext'
import { DataClassName } from '@/Data/const'

const ENTITY_TYPE_KEY = 'entityType'

interface ObjectFilterProps {
  renderLabel?: (hasValue: boolean, onClear: () => void) => React.ReactNode
}

export const ObjectFilter: React.FC<ObjectFilterProps> = ({ renderLabel }) => {
  const { t } = useTranslation()
  const { values, setValues } = useFilterValues()

  const options: Option[] = [
    { label: t('common.filter.allObjects'), value: 'all' },
    { label: t('components.contact.title'), value: DataClassName.PERSON },
    { label: t('pages.companies.title'), value: DataClassName.COMPANY },
  ]

  const currentValue = values[ENTITY_TYPE_KEY] || 'all'
  const selectedOption = options.find((option) => option.value === currentValue)
  const hasValue = currentValue !== 'all'

  const handleClear = () => {
    setValues((prev) => {
      const { [ENTITY_TYPE_KEY]: _removed, ...rest } = prev
      return rest
    })
  }

  const handleChange = (newValue: Option) => {
    const value = newValue.value as string
    if (value === 'all') {
      handleClear()
    } else {
      setValues((prev) => ({ ...prev, [ENTITY_TYPE_KEY]: value }))
    }
  }

  return (
    <>
      {renderLabel && renderLabel(hasValue, handleClear)}
      <SimpleSelect
        name="object-select"
        options={options}
        value={selectedOption}
        onChange={handleChange}
      />
    </>
  )
}
